<template>
  <!-- scroll-table 为滚动table-->
  <!-- fix-table 为滚动table-->
  <div :class="isScroll ? 'scroll-table' : 'fix-table'">
    <header
      :style="{ gridTemplateColumns: getGridTemplateColumns }"
    >
      <div
        class="td"
        v-for="item in columns" :key="item.dataIndex"
      >
        {{ item.title }}
      </div>
    </header>
    <main>
      <van-empty v-if="!tableData || !tableData.length" description="暂无数据" />
      <div v-else>
        <van-swipe-cell :disabled="!isSlide" v-for="(rowData, index) in tableData" :key="rowData[keyField]">
          <div
            class="row-data"
            :style="{ gridTemplateColumns: getGridTemplateColumns }"
          >
            <div
              class="td"
              v-for="item in columns" :key="item.dataIndex"
            >
              <!-- 每个单元格数据 -->
              <div v-if="$scopedSlots.td">
                <slot name="td" :item="rowData" :field="item.dataIndex"></slot>
              </div>
              <div :style="{ textAlign: item.align || 'left' }" v-else>
                {{ getTableTdRenderData(item, rowData) }}
              </div>
            </div>
          </div>
          <slot name="bottom" :index="index" :row="rowData"></slot>
          <template #right>
            <div class="right-btn">
              <van-button square text="删除" type="danger" class="delete-button" @click="() => handleBtnClick('del', rowData, index)"/>
            </div>
          </template>
        </van-swipe-cell>
      </div>
    </main>
  </div>
</template>

<script>
import { SwipeCell, Button, Empty } from 'vant'
export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Empty.name]: Empty
  },
  props: {
    isScroll: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isSlide: {
      type: Boolean,
      default: false
    },
    handleBtnClick: {
      type: Function,
      default: () => {}
    },
    keyField: {
      type: String,
      default: 'id'
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    console.log(this.$slots.td)
    console.log(this.$scopedSlots.td)
  },
  computed: {
    getTableTdRenderData () {
      return (item, rowData) => {
        if (item.type === 'percentage') {
          return rowData[item.dataIndex] ? rowData[item.dataIndex] * 100 + '%' : ''
        }
        if (item.type === 'money') {
          return rowData[item.dataIndex] === 0 || Number(rowData[item.dataIndex]) === 0 ? '' : rowData[item.dataIndex]
        }
        if (item.type === 'goodName') {
          if (rowData['shortName'] && rowData['shortName'].indexOf('*') === -1) { // 没找到*需要拼接
            return `${'*' + rowData['shortName'] + '*'}${rowData[item.dataIndex] || ''}`
          } else {
            return `${rowData['shortName'] ? rowData['shortName'] : ''}${rowData[item.dataIndex] || ''}`
          }
        }
        return rowData[item.dataIndex] || ''
      }
    },
    getGridTemplateColumns () {
      const widths = this.columns.map(i => i.width || '1fr').join(' ')
      return widths
    }
  }
}
</script>

<style lang="less" scoped src="./style.less" />
